module.exports = __webpack_public_path__ + "img/agent_2.8632fd2d.png";